import { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "../providers/AuthContext"; // Import useAuth
import { getAllTenantsForAgreement } from "../api/Tenants"; // Import the function to get user tenants
import { getAgreementByPublicId } from "../api/Agreement"; // Import the function to get user tenants

// Skapa kontexten
const SidebarContext = createContext();

// Custom hook för enkel åtkomst till SidebarContext
export const useSidebar = () => useContext(SidebarContext);

// SidebarProvider som vi kommer använda runt hela appen 
export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { user, getAccessToken } = useAuth(); // Destructure getAccessToken
  const [tenants, setTenants] = useState([]);
  const [agreement, setAgreement] = useState(null);
  const [ agreementPublicId, setAgreementPublicId ] = useState(null);
  const [agreementState, setAgreementState] = useState(false);
  const [isSticky, setIsSticky] = useState(true); // State for sticky sidebar

  const fetchAgreement = async () => {
    try {
      const accessToken = await getAccessToken();
      const activeAgreement = await getAgreementByPublicId(agreementPublicId, accessToken);
      console.log('ACTIVE', activeAgreement)
      setAgreement(activeAgreement);
      setAgreementState(true);
    } catch (error) {
      console.error("Failed to fetch tenants:", error);
    }
  };

  const fetchTenants = async () => {
    try {
      const accessToken = await getAccessToken();
      const activeAgreement = await getAllTenantsForAgreement(agreementPublicId, accessToken);
      console.log(activeAgreement)
      setTenants(activeAgreement);
    } catch (error) {
      setTenants([]);
      console.error("Failed to fetch tenants:", error);
    }
  };

  useEffect(() => {
    if(agreementPublicId) {
      syncData();
    } else {
      setAgreementState(false);
      setTenants([]);
      setAgreement(null);
    }

  }, [agreementPublicId, user]);

  const syncData = () => {
    fetchAgreement();
      fetchTenants();
  }

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, setIsSidebarOpen, tenants, agreement, agreementState, setAgreementState, agreementPublicId, setAgreementPublicId, syncData,  isSticky, setIsSticky }}>
      {children}
    </SidebarContext.Provider>
  );
} 
